export function formatSlope(slope: number, precision: number = 2, asFraction: boolean = false): string {
  const quantize = 10 ** precision;
  const rounded = Math.round(slope * quantize) / quantize;
  if (rounded === 0) {
    return "horizontal";
  }
  if (Math.abs(rounded) === Infinity) {
    return "vertical";
  }
  if (asFraction) {
    const numerator = slope * 12;
    const mod = numerator % 1;
    if (Math.abs(mod - Math.round(mod)) < 10 ** -precision) {
      return `${Math.round(numerator)}:12`;
    }
    return `${Math.round(numerator * quantize) / quantize}:12`;
  }
  return `${rounded}`;
}
